module.exports = __webpack_public_path__ + "img/empty-state-image-v2.0e0b2fe6.svg";